export const checkLeadingAndTrailingSpaces = (text: string) =>
  /^\s|\s$/.test(text)
